export default __webpack_public_path__ + "static/Continuous Integration 1_0-dde74eb3eff575ca0495b114b15d9734.png";